const THUMBNAIL_WIDTH = 1280;
const THUMBNAIL_HEIGHT = 720;

/**
 * Reads image dimensions without uploading the file.
 *
 * @param {Blob} file image file selected by the user.
 * @returns {Promise<{width: number, height: number}>} decoded dimensions.
 */
export const readImageDimensions = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(new Error('thumbnail_read_failed'));
  reader.onload = () => {
    const image = new Image();
    image.onerror = () => reject(new Error('thumbnail_decode_failed'));
    image.onload = () => resolve({ width: image.width, height: image.height });
    image.src = reader.result;
  };
  reader.readAsDataURL(file);
});

/**
 * Validates the exact image dimensions required by Apple and YouTube.
 *
 * @param {Blob} file image file selected by the user.
 * @param {Function} dimensionReader injectable reader used by tests.
 * @returns {Promise<void>}
 */
export const validateThumbnailDimensions = async (file, dimensionReader = readImageDimensions) => {
  const dimensions = await dimensionReader(file);
  if (dimensions.width === THUMBNAIL_WIDTH && dimensions.height === THUMBNAIL_HEIGHT) return;

  throw new Error(
    `You've uploaded an image that is ${dimensions.width}x${dimensions.height}px. ` +
      `We only accept images that are ${THUMBNAIL_WIDTH}x${THUMBNAIL_HEIGHT}px.`
  );
};
